"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Copy = void 0;
const react_1 = __importDefault(require("react"));
const Copy = ({ size, color, outline }) => {
    if (outline) {
        return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M34.7432 34.7401H46.4315V3.57129H15.2627V15.2596", stroke: color || '#25CFBB', strokeWidth: "3.57143", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1.default.createElement("path", { d: "M34.7401 15.2588H3.57129V46.4276H34.7401V15.2588Z", stroke: color || '#25CFBB', strokeWidth: "3.57143", strokeLinecap: "round", strokeLinejoin: "round" })));
    }
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M32.8125 32.8125H42.1875V7.8125H17.1875V17.1875", stroke: color || '#25CFBB', strokeWidth: "3.125", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M32.8125 17.1875H7.8125V42.1875H32.8125V17.1875Z", fill: color || '#25CFBB', stroke: color || '#25CFBB', strokeWidth: "3.125", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.Copy = Copy;
